import React, { Component } from 'react';
import "./input.css";

import Input, { InputAdornment } from 'material-ui/Input';
import Send from 'material-ui-icons/Send';
import IconButton from 'material-ui/IconButton';

class TextEntry extends Component {
  state = {
    text: ''
  }
  additionalData = {
    keystrokes: [],
    meta: { rendered: performance.now() }
  }

  handleChange = event => {
    this.setState({
      text: event.target.value
    })

    if (this.props.isStatic) {
      // if (this.state.text) {
        this.props.addMessage(event.target.value, this.additionalData)
      // }
    }

    if (!this.additionalData.meta) {
      this.additionalData.meta = {}
    }

    let timestamp = performance.now()
    if (!this.additionalData.meta.cachedText) this.additionalData.meta.cachedText = ""
    let key = ""
    if (this.additionalData.meta.cachedText.length < event.target.value.length) {
      key = event.target.value.substring(this.additionalData.meta.cachedText.length)
    } else if (this.additionalData.meta.cachedText.length > event.target.value.length) {
      key = "Backspace"
    }

    if (this.additionalData.meta.typing_timestamp) {
      let time_dif = timestamp - this.additionalData.meta.typing_timestamp
      this.additionalData.keystrokes = this.additionalData.keystrokes.concat([time_dif.toString(), key])
    } else {
      this.additionalData.keystrokes.push(key)
    }

    this.additionalData.meta.typing_timestamp = timestamp
    this.additionalData.meta.cachedText = event.target.value

    // console.log(this.additionalData)
  }

  handleFocus = event => {
    const target = event.target
    if (this.additionalData.meta && this.additionalData.meta.rendered){
      this.additionalData.interaction_delay_time = performance.now() - this.additionalData.meta.rendered
    } else {
      this.additionalData.interaction_delay_time = 0
    }
    setTimeout(() => {
      // console.log(target, target.offsetParent.offsetTop)
      let scrollView = document.getElementById('scroll-content')
      let unscrolledArea = scrollView.scrollHeight - scrollView.scrollTop
      console.log(unscrolledArea, scrollView.offsetHeight)
      // let targetBottom = target.offsetParent.offsetTop + target.offsetParent.offsetHeight

      if (unscrolledArea > scrollView.offsetHeight) {
        target.scrollIntoView({ behavior: "smooth" })
        // Scroll.animateScroll.scrollTo(target.offsetParent.offsetTop - scrollView.offsetHeight)
        // Scroll.animateScroll.scrollTo(target.offsetParent.offsetTop - scrollView.offsetHeight, {
        //   containerId: 'scroll-content',
        //   ignoreCancelEvents: true
        // })
      }

    }, 800)
  }

  handleBlur = event => {
    // if (this.props.isStatic) {
    //   if (this.state.text) {
    //     this.props.addMessage(this.state.text, this.additionalData)
    //   }
    // }
  }

  render() {
    // console.log(this.props)
    const input = (
      <Input
        id="text-response"
        placeholder="Type your response here..."
        color="primary"
        multiline={!this.props.singleline}
        fullWidth
        rowsMax="4"
        value={this.state.text}
        onChange={this.handleChange}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        classes={{root: "text-input-root"}}
        endAdornment={
          !this.props.isStatic &&
          <InputAdornment position="end" style={{height: 0}}>
            <IconButton color="primary" type="submit" onClick={e => { 
                e.preventDefault(); 
                this.additionalData.submission_delay_time = performance.now() - this.additionalData.meta.typing_timestamp
                this.props.addMessage(this.state.text, this.additionalData) 
              }}>
              <Send />
            </IconButton>
          </InputAdornment>
        }
      />
    )
    return (
      <div className={!this.props.isStatic ? "input" : ""}>
        { 
          this.props.isStatic
          ?
            <div className="text-input-container">
              { input }
            </div>
          :
            <form className="text-input-container">
              { input }
            </form>
        }
      </div>
    )
    
  }
}

export default TextEntry;


// WEBPACK FOOTER //
// ./src/components/input/text.js